export const API_URL = 'https://backend.spaclean.ru';
export const WEBSOCKETS = {
    enabled: true,
    key: '6d307364f66ebd2ec5bb',
    cluster: 'eu',
};
export const WEBSOCKETS_OLD = {
    enabled: true,
    key: 'SPACLEAN',
    host: 'backend.spaclean.ru',
    port: 6001,
    encrypted: true,
};
export const DEBUG = false;
export const SHOP_URL = 'https://spaclean.ru/'
